module.exports = __webpack_public_path__ + "media/images/party_hat_confetti-d77122a795ca4fff6857a596bd35ff6c.gif";